import React from "react"
import { PromptsTableContext, PromptsTableContextProps } from "../contexts/PromptsTableContext"

export const usePromptsTableContext = (): PromptsTableContextProps => {
    const context = React.useContext(PromptsTableContext)
    if (!context)
        throw new Error("usePromptsTableContext must be used within a PromptsTableProvider")
    return context
}
